<template>
  <div>
      <dl id='beforeWeBeginDL'>
          <dt class='row no-gutters'><div><img alt='' src="../assets/images/checkmark_dark.svg" style='' /></div><span class='col'>{{$t("text.page1_req1")}}</span></dt>
          <dd v-html='$t("text.page1_req1_text")'></dd>
          <dt v-if="this.$store.state.site==='cibc'" class='row no-gutters'><div><img alt='' src='../assets/images/checkmark_dark.svg' style='margin-right:25px' /></div><span class='col'>{{$t("text.page1_req2")}}</span></dt>
          <dt v-if="this.$store.state.site!=='cibc'&&showBC===true" class='row no-gutters'><div><img alt='' src="../assets/images/checkmark.png" style='margin-right:25px' /></div><span class='col'>{{$t("text.page1_req4")}}</span></dt>
          <dt v-if="this.$store.state.site!=='cibc'&&showBC===false" class='row no-gutters'><div><img alt='' src='../assets/images/checkmark.png' style='margin-right:25px' /></div><span class='col'>{{$t("text.page1_req4_new")}}</span></dt>
          <dd v-if="this.$store.state.site!=='cibc'&&showBC===true" v-html='$t("text.page1_req4_text")'></dd>
          <dd v-if="this.$store.state.site!=='cibc'&&showBC===false" v-html='$t("text.page1_req4_text_new")'></dd>
      </dl>
    <br/>
  </div>
    <div class='whatYoullNeed'>
        <h5 style="padding-left:22px;"><b>{{$t('text.page1_whatyoullneed')}}</b></h5>
        <ul>
            <li style="margin-bottom:12px;">{{$t('text.page1_whatyoullneed1')}}</li>
            <li style="margin-bottom:12px;">{{$t('text.page1_whatyoullneed2')}}</li>
            <li style="margin-bottom:12px;">{{$t('text.page1_whatyoullneed3')}}</li>
        </ul>
    </div>
</template>

<script>
import { initKeywords } from "../utils/keywords.js";
import { eventPageView } from "../utils/adobeAnalytics.js";
import generalConfig from "../config/generalConfig.js";

export default {
  computed: {
    showBC: {
      get() {
        const gc = generalConfig();
        // alert(gc.showBCAfter);
        return this.$moment().isSameOrAfter(gc.showBCAfter);
      }
    }
  },
  mounted(){
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}
    
    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Initialize keyword tooltips
    initKeywords(this);

    // Adobe Analytics
    eventPageView(this, "");
  },
}
</script>


<style>
#beforeWeBeginDL dt img {
margin-left:20px; 
margin-right:25px;
margin-top:-5px;
}
#beforeWeBeginDL dd {
  margin-left:60px;
  margin-bottom: 25px;
}
.textReqTitle{
  font-family: "Fira Sans", sans-serif;
  font-weight:bold;
}
.textReqText {
  font-family: "Fira Sans", sans-serif;
}
/* Redesigned landing (Figma "step 0") */
.redesignedPage1 #stepTitle {
  line-height: 34px;
}
.redesignedPage1 #beforeWeBeginDL {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0;
}
.redesignedPage1 #beforeWeBeginDL + br {
  display: none;
}
.redesignedPage1 #beforeWeBeginDL dt {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 14px;
  min-height: 26px;
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
}
.redesignedPage1 #beforeWeBeginDL dt:has(+ dd) {
  align-items: flex-start;
}
.redesignedPage1 #beforeWeBeginDL dt > div {
  display: flex;
  flex: 0 0 26px;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
}
.redesignedPage1 #beforeWeBeginDL dt img {
  width: 15px;
  height: 15px;
  margin: 0 !important;
}
.redesignedPage1 #beforeWeBeginDL dt > span {
  padding: 0;
}
.redesignedPage1 #beforeWeBeginDL dd {
  margin: -22px 0 0 40px;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
}
.redesignedPage1 #beforeWeBeginDL dd a {
  font-size: 14px;
  line-height: 150%;
}
.redesignedPage1 .whatYoullNeed h5 {
  padding-left: 0 !important;
  margin: 0 0 12px;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #333333;
}
.redesignedPage1 .whatYoullNeed h5 b {
  font-weight: inherit;
}
.redesignedPage1 .whatYoullNeed ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.redesignedPage1 .whatYoullNeed li {
  display: flex;
  gap: 10px;
  margin: 0 !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #333333;
}
.redesignedPage1 .whatYoullNeed li::before {
  content: "\2022";
  flex: 0 0 7px;
  line-height: 18px;
  padding-top: 3px;
}
@media (max-width: 767.98px) {
  .redesignedPage1 #stepTitle {
    line-height: 30px;
  }
  .redesignedPage1 #beforeWeBeginDL {
    gap: 24px;
  }
  .redesignedPage1 #beforeWeBeginDL dt {
    align-items: flex-start;
    gap: 12px;
    min-height: 22px;
    font-size: 14px;
    line-height: 16px;
  }
  .redesignedPage1 #beforeWeBeginDL dt > div {
    flex-basis: 22px;
    width: 22px;
    height: 22px;
  }
  .redesignedPage1 #beforeWeBeginDL dt img {
    width: 12px;
    height: 12px;
  }
  .redesignedPage1 #beforeWeBeginDL dd {
    margin: -26px 0 0 34px;
    font-size: 13px;
    line-height: 140%;
  }
  .redesignedPage1 #beforeWeBeginDL dd a {
    font-size: 13px;
    line-height: 140%;
  }
  .redesignedPage1 .whatYoullNeed h5 {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
  }
  .redesignedPage1 .whatYoullNeed li {
    gap: 8px;
    font-size: 14px;
    line-height: 140%;
  }
  .redesignedPage1 .whatYoullNeed li::before {
    flex-basis: 6px;
    line-height: 16px;
    padding-top: 2px;
  }
}
</style>

